export const QK = {
  init: () => ['init'] as const,

  // Tasks
  tasks: () => ['tasks'] as const,
  taskCategories: (type?: string) => (type ? ['task-categories', type] as const : ['task-categories'] as const),
  taskAttributes: (subCategoryId: number) => ['task-attributes', subCategoryId] as const,
  singleTask: (id: number) => ['single-task', id] as const,
  singleTaskResponses: (id: number) => ['single-task-responses', id] as const,
  filteredTasks: (regionId?: number, subcategoryId?: number, paymentType?: string, search?: string) =>
    ['tasks', regionId, subcategoryId, paymentType, search] as const,

  // Vacancies
  vacancies: () => ['vacancies'] as const,
  vacancyCategories: () => ['vacancy-categories'] as const,
  singleVacancy: (id: number) => ['single-vacancy', id] as const,
  singleVacancyResponses: (id: number) => ['single-vacancy-responses', id] as const,

  // Ads
  ads: () => ['ads'] as const,
  adCategories: () => ['ad-categories'] as const,
  singleAd: (id: number) => ['single-ad', id] as const,
  singleAdResponses: (id: number) => ['single-ad-responses', id] as const,

  // Chat
  chatUser: (id: number) => ['chat-user', id] as const,
  chatMessages: (id: number, type: string) => ['chat-messages', id, type] as const,

  // Specialists
  specialists: () => ['specialists'] as const,
  suitableSpecialists: () => ['suitableSpecialists'] as const,
  singleSpecialist: (id: number) => ['single-specialist', id] as const,

  // Employer
  employer: () => ['employer'] as const,
  employerReviews: () => ['employer-reviews'] as const,
  templateMessages: () => ['templateMessages'] as const,

  // User & Auth
  sessions: () => ['sessions'] as const,
  languages: () => ['languages'] as const,

  // Misc
  regions: () => ['regions'] as const,
  favorites: () => ['favorites'] as const,
  stories: () => ['stories'] as const,
  faq: () => ['faq'] as const,
  banners: () => ['banners'] as const,
  bonusTasks: () => ['bonus-tasks'] as const,
  bonuses: () => ['bonuses'] as const,
} as const;
